import {DashboardActionType} from "../../actions/dashboard/dashboardAction";
import {Commit_Order_List, Today_Order_Increase} from "../../config";
import { v4 as uuidv4 } from 'uuid';

const DefaultDashboardState = {
    dailyFulfilledOrder:{},
    dailyOrder:{},
    dailySKUInfo:{},
    todayOrderIncrease:{},
    todayFulfillmentInfo:{},
    monthlyOrderInfo:{},
    monthlyFulfilledOrderInfo:{},
    totalSkuInv:null,
    orderFulfillmentMetrics :{},
    commitOrderList:[],
    total:0
}

export const dashboardReducer = ( state = DefaultDashboardState, action = {}) =>
{
    switch (action.type) {
        case DashboardActionType.RESET_DASHBOARD:
            return {
                dailyFulfilledOrder:{},
                dailyOrder:{},
                dailySKUInfo:{},
                todayOrderIncrease:{},
                todayFulfillmentInfo:{},
                monthlyOrderInfo:{},
                monthlyFulfilledOrderInfo:{},
                totalSkuInv:null,
                orderFulfillmentMetrics :{},
                commitOrderList:[]
            }
        case DashboardActionType.DAILY_FULFILLED_ORDER:
            return { ...state, dailyFulfilledOrder: action.payload.data }

        case DashboardActionType.DAILY_ORDER:
            return { ...state, dailyOrder: action.payload.data }

        case DashboardActionType.DAILY_SKU_INFO:
            return { ...state, dailySKUInfo: action.payload.data }

        case DashboardActionType.TODAY_ORDER_INCREASE:
            return { ...state, todayOrderIncrease: action.payload.data }

        case DashboardActionType.TODAY_FULFILLMENT_INFO:
            return { ...state, todayFulfillmentInfo: action.payload.data }

        case DashboardActionType.MONTHLY_ORDER_INFO:
            return { ...state, monthlyOrderInfo: action.payload.data }


        case DashboardActionType.MONTHLY_FULFILLED_ORDER_INFO:
            return { ...state, monthlyFulfilledOrderInfo: action.payload.data }

        case DashboardActionType.TOTAL_SKU_INV:
            return { ...state, totalSkuInv: action.payload.data }

        case DashboardActionType.ORDER_FULFILLMENT_METRICS:
            return { ...state, orderFulfillmentMetrics: action.payload.data }

        case DashboardActionType.COMMIT_ORDER_LIST:
            return { ...state, commitOrderList: action?.payload?.data?.odocSoExecuteParamList, total:action?.payload?.data?.totalNum }

        case DashboardActionType.RESET_COMMIT_ORDER_LIST:
            return { ...state, commitOrderList:[], total:0 }
        default:
            return state;

    }

}